export const COLUMNS = [
  {
    Header: '#',
    accessor: 'orderCode',
  },
  {
    Header: 'Date',
    accessor: 'createdAt',
  },
  {
    Id: 'Id',
    accessor: '_id',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
  {
    Header: 'Customer',
    accessor: 'firstName',
  },
  {
    Header: 'Total Revenue (AED)',
    accessor: 'price',
  },
];
